<template>
  <div style="overflow:hidden;" class="mainbox">
    <div class="leftbox">
      <div class="leftboxmain" id="leftboxmain">
         <div class="backlist" @click="$router.go(-1);">
            <span>
              <Icon type="ios-arrow-back" />返回列表
            </span>
          </div>
        <Anchor show-ink :offset-top="160" :scroll-offset="30">
          <AnchorLink href="#dqwz" @on-select="clickgo(dqwz)" title="创客贴"/>
        </Anchor>
      </div>
    </div>
    <div class="rightbox">
      <div class="rightmainbox">
        <div class="mianbaoxie">
          <Breadcrumb separator=">">
            <BreadcrumbItem to="/">分类标签</BreadcrumbItem>
            <BreadcrumbItem>B</BreadcrumbItem>
            <BreadcrumbItem>办公软件/应用</BreadcrumbItem>
            <BreadcrumbItem>创客贴</BreadcrumbItem>
          </Breadcrumb>
        </div>

        <div class="bigshowbox">

          <div class="bigshowdownbox">

                  <dl>
                    <dt><span>进入网站</span></dt>
                    <dd><Icon type="md-heart-outline" /><em>喜欢</em></dd>
                  </dl>    

              </div>

          <div class="bigshowleft">
            <img :src="bigshowpic" />
          </div>
          <div class="bigshowright">
            <div class="bigshowrightbox">
              <div class="logoandmsbox">
                <dl>
                  <dt>
                    <img :src="bigshowlogo" />
                  </dt>
                  <dd>
                    <h5>创客贴</h5>
                    <p>平面设计作图神器_免费设计模板_在线稿定设计印刷</p>
                  </dd>
                </dl>
              </div>
              <div class="anlicodebox">
                <dl>
                  <dt>
                    <img :src="anlizhilogo" />
                  </dt>
                  <dd>
                    <h5>9.2</h5>
                    <p>安利值</p>
                  </dd>
                </dl>
              </div>            


            </div>
          </div>
        </div>

        <div class="recommendbox">相关推荐</div>

        <div class="fenleimain">
          <div class="indexcell" id="b-word-baike">
            <table>
              <tbody>
                <tr>
                  <td>
                    <ul>
                      <li>
                        <span><img :src="anlismlogo"/><i>9.2</i></span>
                        <dl>
                          <dt>
                            <img :src="blogo01" />
                          </dt>
                          <dd>
                            <h5>互动百科</h5>
                            <p>成就组织和个人使协作和管理更高效更愉悦</p>
                          </dd>
                        </dl>
                      </li>
                      <li>
                        <dl>
                          <dt>
                            <img :src="blogo02" />
                          </dt>
                          <dd>
                            <h5>互动百科</h5>
                            <p>成就组织和个人使协作和管理更高效更愉悦</p>
                          </dd>
                        </dl>
                      </li>
                      <li>
                        <dl>
                          <dt>
                            <img :src="blogo03" />
                          </dt>
                          <dd>
                            <h5>互动百科</h5>
                            <p>成就组织和个人使协作和管理更高效更愉悦</p>
                          </dd>
                        </dl>
                      </li>
                      <li>
                        <dl>
                          <dt>
                            <img :src="blogo04" />
                          </dt>
                          <dd>
                            <h5>互动百科</h5>
                            <p>成就组织和个人使协作和管理更高效更愉悦</p>
                          </dd>
                        </dl>
                      </li>
                      <li>
                        <dl>
                          <dt>
                            <img :src="blogo05" />
                          </dt>
                          <dd>
                            <h5>互动百科</h5>
                            <p>成就组织和个人使协作和管理更高效更愉悦</p>
                          </dd>
                        </dl>
                      </li>
                    </ul>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>

    <div class="footerbox"></div>

    <div class="addwebbox">
      <addweb></addweb>
    </div>
    <BackTop :bottom="200" :right="25"></BackTop>
  </div>
</template>

<script>
import addweb from "../publish/addweb";
export default {
  components: { addweb },
  data() {
    return {
      blogo01: require("@/assets/images/b-icon_001.jpg"),
      blogo02: require("@/assets/images/b-icon_002.jpg"),
      blogo03: require("@/assets/images/b-icon_003.jpg"),
      blogo04: require("@/assets/images/b-icon_004.jpg"),
      blogo05: require("@/assets/images/b-icon_005.jpg"),
      bigshowpic: require("@/assets/images/xqypic001.jpg"),
      bigshowlogo: require("@/assets/images/chuangketielogo.jpg"),
      anlizhilogo: require("@/assets/images/anlilogo.png"),
      anlismlogo: require("@/assets/images/alsmlogo.gif")
    };
  }, 
  created(){
    window.scrollTo(0,0)
  },
  mounted(){
    document.querySelector('.ivu-anchor-ink-ball').style.top=8+'px';
  },
  methods:{
    gotoweb(){
      const {href} = this.$router.resolve({
        name: 'foo',
        query: {
          bar
        }
      })
      window.open(href, '_blank')
    }
  }
};
</script>

<style lang="scss" scoped>
.mainbox{ padding-top: 60px;}
html,
body {
  height: 100%;
}
.leftbox {
  height: 100%;
  float: left;
  width: 230px;

  .leftboxmain {
    padding-left: 50px;
    padding-top: 80px;
    font-size: 15px;

    .backlist {
      padding-top: 10px;
      margin-top: 10px;cursor: pointer;
      padding-bottom: 20px; position: fixed;top:90px;
      span {
        border: 1px solid #f3f3f3;
        padding: 10px 20px;
        border-radius: 30px;
        font-size: 13px;
        line-height: 15px;
        i {
          padding-right: 10px;
          font-size: 16px;
          color: #999;
        }
      }
    }

    .zimubox {
      background: #f8f8f8;
      width: 40px;
      padding-top: 10px;
      padding-bottom: 10px;
      border-radius: 30px;
      font-size: 13px;
      margin-top: 15px;
    }
  }
}
.rightbox {
  width: 100%;
  min-height: 673px;

  .rightmainbox {
    padding-left: 250px;

    ul.meitianul li {
      float: left;
      width: 22%;
      max-width: 355px;
      margin-right: 20px;
    }

    .mianbaoxie {
      background: #f7f9fc;
      max-width: 1480px;
      width: 93.5%;
      margin-top: 20px;
      padding: 20px;
    }

    .dailyanlibox {
      overflow: hidden;
      h2 {
        font-size: 18px;
        padding-top: 30px;
        padding-bottom: 20px;
        font-weight: normal;
      }
      .dailylistbox {
        overflow: hidden;
        .alimgbox {
          img {
            max-width: 355px;
            max-height: 214px;
            width: 100%;
          }
        }
        .alimgname {
          padding-top: 8px;
          dl {
            dt {
              float: left;
              min-width: 50px;
              img {
                margin-left: 8px;
                margin-top: 8px;
              }
            }

            dd {
              float: left;
              width: 80%;
              h5 {
                font-size: 15px;
                font-weight: normal;
                color: #333;
              }
              p {
                color: #999;
                overflow: hidden;
                text-overflow: ellipsis;
                /*-webkit-text-overflow:ellipsis;*/
                white-space: nowrap;
              }
            }

            @media screen and (max-width: 1380px) {
              /*当屏幕尺寸小于600px时，应用下面的CSS样式*/
              dd {
                float: left;
                width: 70%;
                h5 {
                  font-size: 15px;
                  font-weight: normal;
                  color: #333;
                }
                p {
                  color: #999;
                  overflow: hidden;
                  text-overflow: ellipsis;
                  /*-webkit-text-overflow:ellipsis;*/
                  white-space: nowrap;
                }
              }
            }
          }
        }
      }
    }

    .bigshowbox {
      background: #f6f8f9;
      position: relative; 
      max-width: 1480px;
      width: 93.5%;
      overflow: hidden;
      box-shadow: 0 0 3.5px #ddd;
      background: #fff;
      margin-top: 20px;

      .bigshowdownbox{ position: absolute; width: 100%; bottom:15%; right: 0; width:32.9%;
        dl{ padding-left:30px;
           dt{ float: left;
              span{ font-size:15px; border: 1px solid #e6e6e6;
               padding: 13px 55px; border-radius: 30px;
            }
           }
           dd{ float: left;padding-left: 30px;
            font-size: 20px;
            i{font-size: 25px; float: left;}
            em{ font-size: 16px; color: #666;float: left;padding-left: 10px;}
           }
        }
      
      }


      @media screen and (max-width: 1300px) {

          .bigshowdownbox{ position: absolute; width: 100%; bottom:15%; right: 0; width:32.9%;
          dl{ padding-left:30px;
            dt{ float: left;
                span{ font-size:13px; border: 1px solid #e6e6e6;
                padding: 13px 40px; border-radius: 30px;
              }
            }
            dd{ float: left;padding-left: 25px;
              font-size: 20px;
              i{font-size: 23px; float: left;}
              em{ font-size: 15px; color: #666;float: left;padding-left: 10px;}
            }
          }
      
       }

      }


     

      .bigshowleft {
        width: 67.1%;
        float: left;
        img {
          max-width: 993px;
          width: 100%;
        }
      }
      .bigshowright {
        width: 32.9%;
        float: left; overflow: hidden; height: 100%;

        .bigshowrightbox {
          overflow: hidden;height: 100%;
          .logoandmsbox {
            width: 66%;
            float: left;
            
            dl {
              padding-left: 10%;
              padding-top: 30px; padding-right: 20px;
              dt {
              }
              dd {
                padding-top: 15px;
                h5 {
                  font-size: 20px;
                  color: #333;
                }
                p {
                  padding-top: 10px;
                  font-size: 15px; color: #999;
                }
              }
            }
          }

          .anlicodebox {
            width: 34%; background: #ffa200;
            float: left; text-align: center;
            dl{ padding-bottom: 38px;
              dt{ padding-top: 28px;}
              dd{ color: #fff;
                h5{  font-size:30px;}
                p{ font-size: 13px;;}
              }
            }
          }

          @media screen and (min-width: 1580px) {
          .anlicodebox{
            dl{
              padding-bottom: 50px;
              dt{ padding-top: 38px;}
            }
          }
         }

         @media screen and (min-width: 910px) and (max-width: 1579px) {
          .anlicodebox{
            dl{
              padding-bottom: 20px;
              dt{ padding-top: 20px;}
            }
          }
         }
        


        }
      }

      


    }

    .recommendbox{ font-size: 17px; padding-top: 30px;}

    .fenleibiaoti {
      background: #f6f8f9;
      clear: both;
      max-width: 1480px;
      width: 93.5%;
      margin-top: 20px;
      h3 {
        font-size: 20px;
        padding-left: 30px;
        padding-top: 20px;
      }
      h2 {
        font-size: 16px;
        padding-top: 15px;
        padding-left: 30px;
        padding-bottom: 25px;
        color: #999;
        font-weight: normal;
      }
    }

    .fenleimain {
      box-shadow: 0 0 3.5px #ddd;
      margin-top: 20px;
      max-width: 1480px;
      width: 93.5%;

      .indexcell {
        table {
          width: 100%;
          border-collapse: collapse;
          thead {
            background: #f6f8f9;
            line-height: 60px;
            b {
              display: inline-block;
              height: 15px;
              width: 3px;
              background: #505050;
            }
            span {
              font-size: 18px;
              margin-right: 10px;
              i {
                padding-left: 20px;
                font-size: 20px;
              }
            }
          }
          tbody {
            background: #fff;
            tr td {
              ul li {
                width: 25%;
                float: left;
                height: 95px;
                border: 1px solid #f3f3f9;
                border-left: none;
                border-top: none;
                position: relative; cursor: pointer;
                span{
                  position: absolute;right: 0; top:0px; background: #fff; padding: 5px;
                  i{ float: left; padding-left:5px; padding-right: 5px;color: #999;}
                  img{float: left; margin-top:2px;}
                }
                dl {
                  padding-top: 25px;
                  dt {
                    float: left;
                    width: 50px;
                    padding-left: 15px;
                    padding-top: 5px;
                  }
                  dd {
                    padding-left: 55px;

                    h5 {
                      font-size: 15px;
                      font-weight: normal;
                      color: #333;
                    }
                    p {
                      color: #999;
                      font-size: 12px;
                      overflow: hidden;
                      text-overflow: ellipsis;
                      /*-webkit-text-overflow:ellipsis;*/
                      white-space: nowrap;
                    }
                  }
                }
              }
              ul li:last-child {
              }
              ul li:first-child {
                border-left: none;
              }

              ul li:hover{ box-shadow: 0 0 8px #ddd;}

              @media screen and (max-width: 1420px) {
                /*当屏幕尺寸小于600px时，应用下面的CSS样式*/
                ul li {
                  width: 25%;
                }
              }
            }
          }
        }
      }
    }

    @media screen and (min-width: 1470px) and (max-width: 1840px) {
      .fenleimain {
        width: 92.5%;
      }
    }

    @media screen and (max-width: 1220px) {
      /*当屏幕尺寸小于600px时，应用下面的CSS样式*/
      .fenleimain {
        width: 94%;
      }
    }
  }
}

.newword {
  display: inline-block;
  margin-left: 5px;
  width: 20px;
  line-height: 20px;
  background: #11be04;
  color: #fff;
  text-align: center;
}
.hotword {
  display: inline-block;
  margin-left: 5px;
  width: 20px;
  line-height: 20px;
  background: #ff0030;
  color: #fff;
  text-align: center;
}

.footerbox {
  height: 60px;
}

>>> .ivu-anchor-ink:before {
  background-color: #fff;
}

>>> .ivu-anchor-link-active>.ivu-anchor-link-title{color: #ffa200;}
>>> .ivu-anchor-link >.ivu-anchor-link-title:hover{color: #ffa200;}

>>> .ivu-anchor-ink-ball {
  width: 18px;
  border-radius: 0;
  margin-top: 3px;
  background-color: #ffa200;
  border: 0 #fff solid;
  height: 3px;
  
}

.addwebbox {
  right: 30px;
  position: fixed;
  top: 38%;
}

@media screen and (max-width: 1300px) {  
  .addwebbox {
    right: 15px;
    position: fixed;
    top: 38%;
  }
}


</style>



// WEBPACK FOOTER //
// src/components/pages/labeldetails.vue